import { render, staticRenderFns } from "./EditAmount.vue?vue&type=template&id=51d0e25d&scoped=true&"
import script from "./EditAmount.vue?vue&type=script&lang=js&"
export * from "./EditAmount.vue?vue&type=script&lang=js&"
import style0 from "./EditAmount.vue?vue&type=style&index=0&id=51d0e25d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d0e25d",
  null
  
)

export default component.exports